<template>
  <div :class="{ 'flex-wrap': pill, 'flex-nowrap': !pill }" class="d-flex">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "TabNav",
  props: {
    id: {
      type: String,
      required: true,
    },
    pill: {
      type: Boolean,
    },
  },
};
</script>
